/**
 * Идентификатор браузера - для партнёрской программы.
 *
 * ЭТО НЕ ОТПЕЧАТОК. Ничего не измеряется и не собирается: при первом визите
 * выдаётся случайная строка и кладётся в `localStorage`. Она нужна ровно для
 * двух вещей - связать переход по партнёрской ссылке с регистрацией и
 * отсечь самопривод «зарегистрировался со своего же браузера».
 *
 * Человек, очистивший хранилище, получит новую строку и просто не будет
 * закреплён - это честная цена за отказ от слежки.
 */
const KEY = 'efira.device.v1';

export function deviceId(): string {
  try {
    const stored = window.localStorage.getItem(KEY);

    if (stored !== null && stored !== '') return stored;

    const fresh = crypto.randomUUID();

    window.localStorage.setItem(KEY, fresh);

    return fresh;
  } catch {
    /* Хранилище закрыто (приватное окно, запрет): работаем без
       закрепления, а не падаем. */
    return 'no-storage';
  }
}

/** Где лежит код партнёрской ссылки до регистрации. */
export const REFERRAL_KEY = 'efira.ref.v1';

export function rememberReferral(code: string): void {
  try {
    window.localStorage.setItem(REFERRAL_KEY, code);
  } catch {
    /* Без хранилища привод не закрепится - и это лучше, чем отказ входа. */
  }
}

export function takeReferral(): string | null {
  try {
    return window.localStorage.getItem(REFERRAL_KEY);
  } catch {
    return null;
  }
}

export function forgetReferral(): void {
  try {
    window.localStorage.removeItem(REFERRAL_KEY);
  } catch {
    /* Нечего забывать. */
  }
}
